module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-1280x160-83b91360c347c701e3d086d0a87996bc.webp";